class oSidebarManager extends window.HTMLDivElement {
    constructor() {
        super();
        this.activeSidebars = [];
        this.currentIndex = 30;

        this.sidebarOpened = this.sidebarOpened.bind(this);
        this.sidebarClosed = this.sidebarClosed.bind(this);
    }

    connectedCallback() {
        document.addEventListener('oSidebar:open', this.sidebarOpened);
        document.addEventListener('oSidebar:close', this.sidebarClosed);
    }

    updateOverlay(sidebar) {
        var firstSidebar = this.activeSidebars[0];
        sidebar?.classList.add('another-sidebar-already-active');
        firstSidebar?.classList.remove('another-sidebar-already-active');
    }

    reopenSidebar(slidePanel, overlay) {
        slidePanel.setAttribute('aria-hidden', true);
        var currentIndex = this.currentIndex;
        setTimeout(() => {
            slidePanel.setAttribute('aria-hidden', false);
            slidePanel.style.zIndex = currentIndex;
            overlay.style.zIndex = currentIndex - 10;
        }, 300);
    }


    sidebarOpened(e) {
        var sidebar = e && e.detail && e.detail.sidebar;
        if (sidebar) {
            var slidePanel = sidebar.slidePanel;
            var overlay = sidebar.overlayClose;
            var isSidebarAlreadyOpened = this.activeSidebars.indexOf(sidebar);
            if (isSidebarAlreadyOpened !== -1) {
                this.activeSidebars.splice(isSidebarAlreadyOpened, 1);
                this.reopenSidebar(slidePanel, overlay);
                this.updateOverlay(sidebar);
            } else {
                slidePanel.style.zIndex = this.currentIndex;
                overlay.style.zIndex = this.currentIndex - 10;
            }
            this.currentIndex += 1;
            this.activeSidebars.push(sidebar);
        }
    }

    sidebarClosed() {
        this.activeSidebars.pop();
        if (!this.activeSidebars.length) {
            this.currentIndex = 30;
        } else {
            this.currentIndex -= 1;
        }
    }
}

customElements.define('o-sidebar-manager', oSidebarManager, {
    extends: 'div'
});
